// Consume and clear the internal-render fragment before any telemetry or app
// module can observe location.href. This import must remain first.
import "./lib/internalRenderBootstrap";
import "./instrument";

import React from "react";
import ReactDOM from "react-dom/client";
import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

// Mantine styles
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/tiptap/styles.css";

// Session recording player styles
import "rrweb-player/dist/style.css";

// App styles
import "./index.css";

import App from "./App";
import { theme } from "./theme";

// Create TanStack Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0, // Data is immediately stale - always refetch on mount
      refetchOnWindowFocus: true, // Refetch when user returns to the tab/window
      refetchOnMount: true, // Always refetch when component mounts
      retry: 1,
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <MantineProvider theme={theme}>
        <Notifications position="top-right" />
        <App />
        <ReactQueryDevtools initialIsOpen={false} />
      </MantineProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
